export default __webpack_public_path__ + "static/media/master-bg.b299f785.png";